// Shared theme palettes — extracted from cutting-dashboard.jsx so the
// time-clock kiosk entry (kiosk.html) can render without importing the
// full ~22k-line dashboard SPA. The kiosk is always dark and uses C_DARK;
// the dashboard imports both and toggles `C` between them at runtime.
export const C_DARK = {
  bg:'#070b12', surface:'#0f1620', raised:'#141d2a', deep:'#05080d',
  border:'#1e3247', text:'#dbe9f4', muted:'#6b8298', accent:'#f0a500',
  cyan:'#06d4f0',
  cyanDim:'#0e7a8e',
  cyanGlow:'rgba(6,212,240,.30)',
  amberGlow:'rgba(240,165,0,.45)',
  redGlow:'rgba(248,113,113,.4)',
  greenGlow:'rgba(16,185,129,.35)',
  hairline:'rgba(6,212,240,.16)',
  cyanText:'#001218',  // contrast color for text on top of cyan-filled buttons
  // Sticky header gradient bottom — dark in dark mode, slightly tinted white in light.
  headerFade: 'rgba(15,22,32,.92)',
  // Subtle wash for stat pills, tab chips, stripes.
  chipBg: 'rgba(255,255,255,.05)',
  chipBgStrong: 'rgba(255,255,255,.08)',
  // Text color used on top of the cyan accent (e.g. Sync inFlow button).
  cyanText: '#001218',
}
export const C_LIGHT = {
  bg:'#e9eef3', surface:'#f5f8fb', raised:'#ffffff', deep:'#e1e7ee',
  border:'rgba(15,32,48,.16)', text:'#0e1722', muted:'#5a6a7a', accent:'#b27800',
  cyan:'#0891b2',          // deeper cyan reads cleanly on white
  cyanDim:'#0e7490',
  cyanGlow:'rgba(8,145,178,.28)',
  amberGlow:'rgba(180,120,0,.35)',
  redGlow:'rgba(220,38,38,.3)',
  greenGlow:'rgba(5,150,105,.3)',
  hairline:'rgba(8,145,178,.22)',
  cyanText:'#ffffff',
  headerFade: 'rgba(255,255,255,.92)',
  chipBg: 'rgba(15,32,48,.05)',
  chipBgStrong: 'rgba(15,32,48,.08)',
  // White text on the deeper cyan reads way better than dark text in light mode.
  cyanText: '#ffffff',
}
